import { h } from 'preact';

import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';

import styles from '../../components/global.css';

export default function Search() {

  return (
    <>
      <Paper className={styles.originArea}>
        <div className={styles.urlListHeader}>
          <Typography variant="h5">Search Input</Typography>
        </div>
      </Paper>
      <Paper className={styles.originArea}>
        <div className={styles.urlListHeader}>
          <Typography variant="h5">Search Results</Typography>
        </div>
      </Paper>
    </>
  );
}
